module.exports = __webpack_public_path__ + "static/img/5鱼尾掉头.d8744b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/解决方案/农机无人驾驶解决方案/5鱼尾掉头.png
// module id = u6FV
// module chunks = 0